import type { JSX } from 'react';
import { Icon } from '../primitives/Icon';
import { StatusChip } from '../primitives/Chips';
import { dataSourceKind } from '@/data';

/**
 * Footer.
 *
 * The year is computed, never hard-coded — a brand non-negotiable, because a
 * stale copyright year on a client-facing screen is a visible defect.
 *
 * The classification chip is deliberate too: this build carries illustrative
 * client-named data and says so on every screen.
 */
export function Footer(): JSX.Element {
  const year = new Date().getFullYear();
  const envLabel = import.meta.env.VITE_ENVIRONMENT_LABEL;

  return (
    <footer className="pnet-footer">
      <span className="lang">
        <Icon name="globe" />
        English (US)
      </span>
      <span className="caption">
        Prototype · illustrative data · Partnership Net 2.1
        {envLabel === undefined ? '' : ` · ${envLabel}`} · data: {dataSourceKind}
      </span>
      <span className="brandmark">
        <StatusChip kind="info" label="Internal" />
        <span>
          Terms of use &nbsp;|&nbsp; Copyright {year} <strong>Partnership Net</strong>
        </span>
      </span>
    </footer>
  );
}
